// Rate Limiting for Security
export class RateLimiter {
    constructor(maxAttempts = 5, windowMs = 15 * 60 * 1000) { // 5 attempts per 15 minutes
        this.maxAttempts = maxAttempts;
        this.windowMs = windowMs;
        this.attempts = new Map();
    }

    // Check if IP/user is rate limited
    isRateLimited(identifier) {
        const now = Date.now();
        const userAttempts = this.attempts.get(identifier) || [];
        
        // Clean old attempts
        const validAttempts = userAttempts.filter(time => now - time < this.windowMs);
        
        if (validAttempts.length >= this.maxAttempts) {
            return {
                limited: true,
                resetTime: Math.ceil((validAttempts[0] + this.windowMs - now) / 1000)
            };
        }
        
        return { limited: false };
    }

    // Record failed attempt
    recordAttempt(identifier) {
        const now = Date.now();
        const userAttempts = this.attempts.get(identifier) || [];
        userAttempts.push(now);
        
        // Keep only recent attempts
        const validAttempts = userAttempts.filter(time => now - time < this.windowMs);
        this.attempts.set(identifier, validAttempts);
    }

    // Reset attempts for user (on successful login)
    resetAttempts(identifier) {
        this.attempts.delete(identifier);
    }

    // Get remaining attempts
    getRemainingAttempts(identifier) {
        const userAttempts = this.attempts.get(identifier) || [];
        const now = Date.now();
        const validAttempts = userAttempts.filter(time => now - time < this.windowMs);
        return Math.max(0, this.maxAttempts - validAttempts.length);
    }
}

// Global rate limiter instance
export const loginRateLimiter = new RateLimiter(5, 15 * 60 * 1000); // 5 attempts per 15 minutes
export const passwordResetRateLimiter = new RateLimiter(3, 60 * 60 * 1000); // 3 attempts per hour